// React Imports
import React from 'react';
import ReactDOM from 'react-dom';
import {Route, Switch, Redirect} from 'react-router-dom';

// Redux Imports
import {Provider} from 'react-redux';
import {createStore, applyMiddleware, compose} from 'redux';
import {ConnectedRouter, routerMiddleware} from 'react-router-redux'
import {createBrowserHistory} from 'history'

// Redux Reducer Imports
import reducers from './js/reducers';

// Global CSS Imports
import 'normalize.css';
import '../node_modules/font-awesome/css/font-awesome.css';
import './styles/index.css';

// Layout Imports
import LayoutMain from './js/layouts/LayoutMain';

// Page Imports
import MainPage from './js/pages/MainPage';
import AboutPage from './js/pages/AboutPage';
import PortfolioPage from './js/pages/PortfolioPage';
import PhotographyPage from './js/pages/PhotographyPage';
import ResumePage from './js/pages/ResumePage';
import ContactPage from './js/pages/ContactPage';

window.scrollTo(0,1);

// Create a history of your choosing (we're using a browser history in this case)
const history = createBrowserHistory();

history.listen(function (location) {
  window.ga('send', 'pageview', location.pathname);
});

// Build the middleware for intercepting and dispatching navigation actions
const middleware = routerMiddleware(history);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

let store = createStore(reducers, composeEnhancers(applyMiddleware(middleware)));

document.title = "Ander Murias | Dream Maker & Software Developer";

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <LayoutMain>
        <Switch>
          <Route exact path="/" component={MainPage}/>
          <Route path="/about" component={AboutPage}/>
          <Route path="/portfolio" component={PortfolioPage}/>
          <Route path="/photography" component={PhotographyPage}/>
          <Route path="/resume" component={ResumePage}/>
          <Route path="/contact" component={ContactPage}/>
          <Redirect to="/"/>
        </Switch>
      </LayoutMain>
    </ConnectedRouter>
  </Provider>
  , document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js